import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../../actions';

const FileSidebarEmptyState = ({
  info, icon, wiki, video, title, openModal,
}) => {
  const intl = useIntl();

  return (
    <div className="file-sidebar-empty-state">
      <span className="file-sidebar-empty-state-title">
        {icon && (
          <i className={icon} />
        )}
        {info}
      </span>
      {(wiki || video) && (
        <div className="file-sidebar-empty-state-buttons">
          {wiki && (
            <Button color="link" size="sm" tag="a" href={wiki} target="_blank">
              <i className="far fa-book mr-1" />
                {intl.formatMessage({ defaultMessage: 'Learn more' })}
            </Button>
          )}
          {video && (
            <Button
              size="sm"
              onClick={() => openModal(video, title)}
            >
              <i className="far fa-play mr-1" />
              {intl.formatMessage({ defaultMessage: 'Watch video' })}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

FileSidebarEmptyState.propTypes = {
  info: PropTypes.string.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string,
  wiki: PropTypes.string,
  video: PropTypes.string,
  openModal: PropTypes.func.isRequired,
};

FileSidebarEmptyState.defaultProps = {
  icon: null,
  title: '',
  wiki: null,
  video: null,
};

const mapDispatchToProps = dispatch => ({
  openModal: (url, title) => {
    dispatch(showModal('VideoPlayerModal', {
      className: 'modal-video-player',
      url,
      title,
      backdrop: true,
    }));
  },
});

export default connect(null, mapDispatchToProps)(FileSidebarEmptyState);
